export default function (num) {
  return numToWords(num).trim();
}

/**
 * Convert whole numbers to words. Does not support negative numbers.
 *
 * Stolen from https://gist.github.com/ForbesLindesay/5467742
 * @param num
 * @returns {string}
 */
function numToWords(num) {
  let numString = num.toString();

  // return empty string for negative numbers
  if (num < 0) return '';

  if (num === 0) return 'zero';

  // the case of 1 - 20
  if (num < 20) {
    return ones[num];
  }

  if (numString.length === 2) {
    return tens[numString[0]] + ' ' + ones[numString[1]];
  }

  // 100 and more
  if (numString.length === 3) {
    if (numString[1] === '0' && numString[2] === '0') return ones[numString[0]] + ' hundred';
    else return ones[numString[0]] + ' hundred and ' + numToWords(+(numString[1] + numString[2]));
  }

  if (numString.length === 4) {
    const end = +(numString[1] + numString[2] + numString[3]);
    if (end === 0) return ones[numString[0]] + ' thousand';
    if (end < 100) return ones[numString[0]] + ' thousand and ' + numToWords(end);
    return ones[numString[0]] + ' thousand ' + numToWords(end);
  }
}

const ones = [
  '',
  'one',
  'two',
  'three',
  'four',
  'five',
  'six',
  'seven',
  'eight',
  'nine',
  'ten',
  'eleven',
  'twelve',
  'thirteen',
  'fourteen',
  'fifteen',
  'sixteen',
  'seventeen',
  'eighteen',
  'nineteen',
];
const tens = ['', '', 'twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety'];
